<template>
    <div>
        <b-card :title="$translate('crm_settings')" class="inner-page crm-setting p-3 form-sample">
            <b-overlay :show="updating" rounded="sm">
                <b-card-body>
                    <b-form class="p-0">
                        <b-col cols="12" class="mt-3 dd">
                            <label id="fieldset-type_id" for="select-type_id" class="mb-3"><strong>{{ $translate('asset_type')
                            }}</strong>
                            </label>
                            <b-form-select class="form-control" id="select-type_id" v-model="formData.type_id" :options="types"
                                text-field="name" value-field="id">
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" class="dd mt-3">
                            <label id="fieldset-vendor_id" for="select-vendor_id" class="mb-3"><strong>{{
                                $translate('asset_vendor') }}</strong>
                            </label>
                            <b-form-select class="form-control" id="select-vendor_id" v-model="formData.vendor_id"
                                :options="vendors" text-field="name" value-field="id">
                            </b-form-select>
                        </b-col>
                        <b-col class="text-center my-4">
                            <button id="update-settings-btn" variant="link" v-if="hasPermissionUpdate" @click="updateTypes"
                                class="btn btn mt-4 btn-info btn-fw me-2 btn-primary">{{ $updateLabel() }}</button>
                        </b-col>
                    </b-form>
                </b-card-body>
            </b-overlay>
        </b-card>
    </div>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'crmSettings',
    mixins: [popupMixins, permissionsMixins],
    data: () => ({
        formData: {
            type_id: null,
            vendor_id: null,
        },
        updating: false,
    }),

    computed: {
        componentName() { return this.$translate('crm_settings') },
        crmSettingValue() {
            const crmSettingValue = this.$store.getters['company/crmSettingValue']
            console.log('computed  crmSettingValue', crmSettingValue)
            return crmSettingValue
        },

        types() {
            return this.$store.state.assets.types
        },

        vendors() {
            return this.$store.state.assets.vendors
        },

        crmsettingsKey() {
            return this.$store.state.company.settingKeys.crmsettingsKey
        },
    },

    watch: {
        crmSettingValue: {
            handler: function (val) {
                console.log('watch crmSettingValue', val)
                this.updateModel(val)
            },
            deep: true,
        },
        vendors: {
            handler: function (val) {
                console.log('watch vendors', val)
            },
            deep: true,
        },
    },

    created() {
        this.$store.dispatch('assets/listTypes')
        this.$store.dispatch('assets/listVendors')
    },

    async mounted() {
        await this.$store.dispatch(
            'company/fetchConfiguration',
            this.crmsettingsKey
        )
        this.$nextTick(() => {
            this.updateModel(this.crmSettingValue)
        })
    },

    methods: {
        updateModel(crmSettingValue) {
            this.formData = crmSettingValue
        },
        async updateTypes() {
            try {
                this.updating = true
                const text_value = JSON.stringify(this.formData)
                const bool_value = false

               await this.$store.dispatch('company/updateConfiguration', {
                    key: this.crmsettingsKey,
                    text_value,
                    bool_value,
                })

                this.genericToast(this.componentName, this.$translate('updated'), 'success', `${this.componentName} ${this.$translate('update_alert')}`)

            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.updating = false
            }
        },
    },
}
</script>
